import React from "react";

const YouTubeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
    >
      <g clipPath="url(#clip0_2_592)">
        <path
          d="M16.7037 13.1272C16.7115 13.1662 16.7141 13.2026 16.7115 13.2416C16.7193 13.2026 16.7193 13.1662 16.7037 13.1272Z"
          fill="#364F8E"
        />
        <path
          d="M13.8651 6.92493C5.85364 6.92493 5.71327 7.63718 5.71327 13.2C5.71327 18.7628 5.85364 19.4751 13.8651 19.4751C21.8766 19.4751 22.017 18.7628 22.017 13.2C22.017 7.63718 21.8766 6.92493 13.8651 6.92493ZM16.462 13.6107L12.7838 15.3887C12.4874 15.5317 12.1443 15.3159 12.1443 14.9884V11.513C12.1443 11.188 12.4822 10.9723 12.776 11.1074L16.4542 12.8049C16.5972 12.8699 16.6777 12.9946 16.7011 13.1272C16.7167 13.1636 16.7167 13.2026 16.7089 13.2416C16.6985 13.3898 16.618 13.5353 16.462 13.6133V13.6107Z"
          fill="#364F8E"
        />
        <path
          d="M21.4165 26.4H5.78346C2.81489 26.4 0.400002 23.9851 0.400002 21.0165V5.38346C0.400002 2.41489 2.81489 0 5.78346 0H21.4165C24.3851 0 26.8 2.41489 26.8 5.38346V21.0165C26.8 23.9851 24.3851 26.4 21.4165 26.4ZM5.78346 1.47389C3.62592 1.47389 1.87389 3.22851 1.87389 5.38346V21.0165C1.87389 23.1741 3.62852 24.9261 5.78346 24.9261H21.4165C23.5741 24.9261 25.3261 23.1715 25.3261 21.0165V5.38346C25.3261 3.22592 23.5715 1.47389 21.4165 1.47389H5.78346Z"
          fill="#364F8E"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_592">
          <rect
            width="26.4"
            height="26.4"
            fill="white"
            transform="translate(0.400002)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default YouTubeIcon;
